import { Component, NgZone, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Listener } from 'eventemitter2';
import { Easing } from '../animations';
import { NotificationService } from './notification.service';
import { INotificationComponent, Notification } from '@models/notification.interface';
import { animateElement, sleep } from '@utils';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit, OnDestroy {
  @ViewChild('notificationsContainer', { read: ViewContainerRef }) notificationsContainer: ViewContainerRef;

  subscribers: Listener[] = [];

  constructor(private notificationService: NotificationService, private ngZone: NgZone) {}

  ngOnInit(): void {
    this.subscribers.push(
      this.notificationService.onNotification.on('add', (notification: Notification) => {
        this.createNotification(notification);
      }) as Listener,
    );

    this.subscribers.push(
      this.notificationService.onNotification.on('close', (notification: Notification) => {
        this.closeNotification(notification);
      }) as Listener,
    );
  }

  createNotification(notification: Notification): void {
    const notificationComponentRef = this.notificationsContainer.createComponent<INotificationComponent>(notification.type);
    notificationComponentRef.instance.notification = notification;
    notification.hostView = notificationComponentRef.hostView;
    notification.elementRef = notificationComponentRef.location;
    notification.elementRef.nativeElement.style.display = 'block';
    if (!document.hidden) {
      animateElement(
        (p: number) => {
          notification.elementRef.nativeElement.style.opacity = p.toString();
          notification.elementRef.nativeElement.style.transform = `translateX(${-200 + 200 * p}px)`;
        },
        500,
        Easing.easeInOutCubic,
        this.ngZone,
      );
    }
  }

  async closeNotification(notification: Notification): Promise<void> {
    if (!notification) return;
    try {
      if (!document.hidden) {
        await Promise.race([
          animateElement(
            (p: number) => {
              notification.elementRef.nativeElement.style.opacity = (1 - p).toString();
              notification.elementRef.nativeElement.style.transform = `translateX(${-200 * p}px)`;
            },
            500,

            Easing.easeInOutCubic,
            this.ngZone,
          ),
          sleep(600),
        ]);
      }
    } finally {
      if (notification.hostView && !notification.hostView.destroyed) {
        notification.hostView.destroy();
      }
    }
  }

  ngOnDestroy(): void {
    for (const subscriber of this.subscribers) {
      subscriber.off();
    }
  }
}
